import { Loading } from '@design/components/loading/Loading';

import { useThemeStore } from '../theme-controller/stores/useThemeStore';

export const Loader = () => {
  const colorScheme = useThemeStore(state => state.colorScheme);

  return <Loading colorScheme={colorScheme} />;
};
